import React, {useState} from "react";
import {Button} from "primereact/button";
import {Person} from "../types/Person";
import {Workshop} from "../types/Workshop";

interface ArtisanTextFieldProps {
  label: string;
  value: string;
  assignments: Array<{
    type: 'person' | 'workshop';
    personId?: string;
    workshopId?: string;
    uncertain: boolean;
  }>;
  people: Person[];
  workshops: Workshop[];
  onChange: (value: string) => void;
}

const ArtisanTextField: React.FC<ArtisanTextFieldProps> = ({
                                                             label,
                                                             value,
                                                             assignments,
                                                             people,
                                                             workshops,
                                                             onChange
                                                           }) => {
  const [isEditMode, setIsEditMode] = useState(false);

  const generateDefaultText = (): string => {
    return assignments.map(assignment => {
      let name = '';

      if (assignment.type === 'person' && assignment.personId) {
        const person = people.find(p => p.id === assignment.personId);
        if (person) {
          name = `${person.name} ${person.surname}`;
        }
      } else if (assignment.type === 'workshop' && assignment.workshopId) {
        const workshop = workshops.find(w => w.id === assignment.workshopId);
        if (workshop) {
          name = workshop.location ? `${workshop.name} (${workshop.location})` : workshop.name;
        }
      }

      return assignment.uncertain ? `${name} (?)` : name;
    }).filter(name => name).join(', ');
  };

  const displayText = isEditMode || value ? value : generateDefaultText();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    onChange(value);
  };

  const handleBlur = () => {
    if (!value) {
      onChange('');
      setIsEditMode(false);
    }
  };

  const handleEditClick = () => {
    setIsEditMode(true);

    // If value is empty, populate with default text
    if (!value) {
      onChange(generateDefaultText());
    }
  };

  return (
    <div className="mb-4">
      <div className="relative">
        <input
          id={`artisan-${label}`}
          name={`artisan-${label}`}
          type="text"
          value={displayText}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={!isEditMode}
          className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-sm focus:outline-none focus:ring-1 focus:ring-gray-800 focus:border-transparent transition duration-300 disabled:bg-gray-100 disabled:text-gray-500"
        />
        <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
          <Button
            type="button"
            icon="fa fa-pen-to-square"
            size="small"
            text
            className="p-1 text-black hover:text-gray-700 focus:outline-none"
            onClick={handleEditClick}
            title={`Edit ${label.toLowerCase()} manually`}
          />
        </div>
      </div>
    </div>
  );
};

export default ArtisanTextField;

